angular.module('zc.commonApi')

.factory 'ProjectCookie', ($resource, $q, BaseProjectCrudService) ->
  class ProjectCookie extends BaseProjectCrudService

  new ProjectCookie(
    $resource
    $q
    '/api/projects/:projectId/cookies/:id'
    'cookie'
    'cookies'
  )




// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/cookie.service.coffee